/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Info/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Info({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsRequestPayment/Content/ContactMethodSelect/Info"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let contactMethodsPhonesValueData = fromData.useDataValue({ viewPath,
context: 'contact_methods',
path: 'phones',
})
let contactMethodsEmailsValueData = fromData.useDataValue({ viewPath,
context: 'contact_methods',
path: 'emails',
})
let aggregateData = fromHelpers.getView(contactMethodsPhonesValueData, contactMethodsEmailsValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}